import { fetchPersea } from "@/config/axios/config-axios";

export const getNFT = async (params = {}) => {
    return await fetchPersea(`nft`, 'GET', params);
};


export const getNFTRecommendedByCollectionKey = async (params={}) => {
    return await fetchPersea(`nft/recommended-claim`, 'GET', params);
};
